<script>
    import Preloader from '../components/Preloader.svelte';
    import { store } from '../Store.svelte';
    import {
        fetchPayPalCancelBA,
        fetchPayPalCaptureBA,
    } from '../clients/PaymentClient.svelte';

    $: loading = !$store.purchaseStatus.paypalCompleteAgreement;
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const ba_token = urlParams.get('ba_token');
    let message = $store.purchaseStatus.paypalMessageAgreement;
    let overridePayment =
        $store.purchaseStatus.rptEliminaPagoAnticipado != null
            ? $store.purchaseStatus.rptEliminaPagoAnticipado
            : false;
    if (!$store.purchaseStatus.paypalCompleteAgreement && !overridePayment) {
        fetchPayPalCancelBA($store, token, ba_token).then((response) => {
            if (response.code == '00') {
                $store.purchaseStatus.paypalCompleteAgreement = true;
                $store.purchaseStatus.paypalBillingAgreement = null;
            }
            $store.purchaseStatus.paypalMessageAgreement = response.message;
            message = $store.purchaseStatus.paypalMessageAgreement;
            loading = false;
        });
    } else {
        setTimeout(function () {
            message = 'No puede cancelar el acuerdo de pagos.';
            loading = false;
        }, 2000);
    }

    function closeTab() {
        window.close();
    }
</script>

<div>
    {#if loading}
        <div class="pure-g justify-content-center">
            <div class="pure-u-1">
                <div class="text-center">
                    <Preloader status={$store.purchaseStatus.status} />
                </div>
            </div>
        </div>
    {:else}
        <div class="pure-g justify-content-center {!loading ? '' : 'hide'}">
            <div class="pure-u-1 pure-u-md-3-4 pure-u-lg-3-5">
                {#if $store.purchaseStatus.paypalCompleteAgreement}
                    <div class="alert alert--error alert--with-icon">
                        <svg class="icon" aria-hidden="true"
                            ><use
                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-check-circle"
                            /></svg
                        >
                        <p>{message} - Acuerdo de pagos cancelado.</p>
                    </div>
                {:else}
                    <div class="alert alert--error">
                        <p>{message}</p>
                    </div>
                {/if}
                <div class="text-center">
                    <button
                        on:click={closeTab}
                        type="button"
                        class="pure__button pure__button--base"
                    >
                        Siguiente
                    </button>
                </div>
            </div>
        </div>
    {/if}
</div>
